<template>
  <div class="section-wrap" id="schools-modal-template">
    <h3 class="section-title mt-40">학력사항 기본정보</h3>
    <div class="table-wrap mt-16">
      <table class="table-body-only">
            <caption>학력사항 정보 테이블</caption>
        <colgroup class="pc-cell">
          <col style="width: 160px;" />
          <col />
        </colgroup>
        <colgroup class="mo-cell">
          <col style="width: 88px;" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              최종학력 <span class="must">*</span>
            </th>
            <td>
              <div class="input-area mo-size wid400">
                <select title="최종학력 선택" v-model="lastEdulv">
                  <option value="">최종학력 선택</option>
                  <option v-for="(educationLevel, index) in educationLevels" :key="index" :value="educationLevel.code">{{ educationLevel.name }}</option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">
              최종학력<br>졸업여부 <span class="must">*</span>
            </th>
            <td>
              <div class="input-area mo-size wid400">
                <select title="최종학력 졸업여부 선택" v-model="lastEdulvStat" :disabled="isDisabled">
                  <option value="">최종학력 졸업여부 선택</option>
                  <option v-for="(graduationStatuse, index) in graduationStatuses" :key="index" :value="graduationStatuse.code">{{ graduationStatuse.name }}</option>
                </select>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="loop-tbl" v-for="(school, index) in schools" :key="school.sortOrder">
      <div class="multi-item-title mt-40" v-if="index === 0">
        <h3 class="section-title ">학교 및 전공정보</h3>
        <div class="check-util">
          <button type="button" class="btn btn-line-box btn-sm" @click="reset(index)">
            <i class="ico ico-refresh"></i>
            입력항목 초기화
          </button>
        </div>
      </div>
      <div class="multi-item-title mt-40" v-else>
        <h3 class="section-title ">추가정보{{ index }}</h3>
        <div class="check-util">
          <button type="button" class="btn btn-line-box btn-sm" @click="reset(index)">
            <i class="ico ico-refresh"></i>
            입력항목 초기화
          </button>
          <button type="button" class="btn btn-line-box btn-sm" @click="remove(index)">
            <i class="ico ico-trash"></i>
            삭제하기
          </button>
        </div>
      </div>
      <div class="table-wrap">
        <table class="table-body-only">
          <caption>학교 및 전공정보 테이블</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px;" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px;" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">학력구분</th>
              <td>
                <div class="input-area mo-size wid400">
                  <select title="학력구분 선택" v-model="school.schoolType" :disabled="isDisabled">
                    <option value="">학력구분 선택</option>
                    <option v-for="(schoolType, index) in schoolTypes" :key="index" :value="schoolType.code">{{ schoolType.name }}</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">학교명</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="school.schoolName" :disabled="isDisabled" title="학교명" @input="limitBytes($event, school, 'schoolName', 200, '학교명')"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">전공</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="school.major" :disabled="isDisabled" title="전공" @input="limitBytes($event, school, 'major', 100, '전공')"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">부전공</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="school.subMajor" :disabled="isDisabled" title="부전공" @input="limitBytes($event, school, 'subMajor', 100, '부전공')"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">졸업여부</th>
              <td>
                <div class="input-area mo-size wid400">
                  <select title="졸업여부 선택" v-model="school.graduationStatus" :disabled="isDisabled">
                    <option value="">졸업여부 선택</option>
                    <option v-for="(graduationStatuse, index) in graduationStatuses" :key="index" :value="graduationStatuse.code">{{ graduationStatuse.name }}</option>
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Add Resume Card -->
    <div class="flex flex-direction align-items-center mt-40">
      <button type="button" class="add-resume-icon" @click="add" :disabled="isDisabled">
        <i class="ico ico-plus48"></i>
        <p>추가하기</p>
      </button>
      <p>클릭하여 추가 정보를 입력하실 수 있습니다.</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Axios from 'axios';
import { apiHandler, byteLimitMixin } from './resume-common';

export default ({
  name: 'schools-modal-template',
  mixins: [byteLimitMixin],
  props: ['schoolsModal', 'indbankNo', 'lastEducationLevels', 'educationLevels', 'graduationStatuses', 'schoolTypes'],
  data() {
    return {
      lastEdulv: '',
      lastEdulvStat: '',
      schools: [],
      newSchool: {
        schoolType: '',
        schoolName: '',
        major: '',
        subMajor: '',
        graduationStatus: '',
        sortOrder: '',
      },
      isDisabled: false,
    };
  },
  watch: {
    schoolsModal: {
      handler(newVal) {
        if (newVal && this.indbankNo) {
          this.getEducations();
          this.getBasic();
        }
      },
      immediate: true,
    },
    lastEdulv: {
      // 최종 학력이 무학력일 경우 최종 학력을 제외한 항목 disabled 처리
      handler(newVal) {
        this.isDisabled = (newVal === 'JB01001');
      },
      immediate: true,
    },
  },
  methods: {
    getEducations() {
      Axios.get(`/api/idb/${this.indbankNo}/schools`).then((response) => {
        if (response.data.success === 'R') {
          this.schools = response.data.data.map((school) => {
            const newSchool = { ...school };
            if (!newSchool.schoolType) {
              newSchool.schoolType = '';
            }
            if (!newSchool.graduationStatus) {
              newSchool.graduationStatus = '';
            }
            return newSchool;
          });
          if (response.data.data.length === 0) this.add();
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getBasic() {
      Axios.get(`/api/idb/${this.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          const data = response.data.data;
          this.lastEdulv = (!data.lastEdulv) ? '' : data.lastEdulv;
          this.lastEdulvStat = (!data.lastEdulvStat) ? '' : data.lastEdulvStat;
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    updateSchools() {
      if (this.vaildCheck() && confirm('저장 하시겠습니까?')) {
        const lastEdulvParam = { lastEdulv: this.lastEdulv, lastEdulvStat: this.lastEdulvStat };
        Axios.post(`/api/idb/${this.indbankNo}/basic`, lastEdulvParam).then(() => {
        }).catch((e) => {
          apiHandler.handleError(e);
        });

        Axios.post(`/api/idb/${this.indbankNo}/schools`, { schools: this.schools }).then((response) => {
          apiHandler.handleSaveSuccess(response, (res) => {
            // 완성도 업데이트 (올바른 경로로 접근)
            if (res.data && res.data.data.completionRate !== undefined) {
              this.$emit('update:CompletionRate', res.data.data.completionRate);
            }
          });
        }).catch((e) => {
          apiHandler.handleError(e);
        });
      }
    },
    vaildCheck() {
      if (!this.lastEdulv) {
        alert('최종학력을 선택해주세요.');
        return false;
      } else if (this.lastEdulv === 'JB01001') { // 무학력일 경우 졸업여부 및 학교 정보를 등록하지 않음
        return true;
      }
      if (!this.lastEdulvStat) {
        alert('최종학력 졸업여부 선택해주세요.');
        return false;
      }
      return true;
    },
    add() {
      // 각 항목마다 독립적인 새 객체 생성
      const newSchoolItem = {
        schoolType: '',
        schoolName: '',
        major: '',
        subMajor: '',
        graduationStatus: '',
        sortOrder: this.schools.length + 1,
      };
      this.schools.push(newSchoolItem);
    },
    reset(index) {
      const message = '입력하신 내용을 초기화하시겠습니까?';

      if (confirm(message)) {
        // 모든 항목에 대해 입력값만 초기화
        const resetSchoolItem = {
          schoolType: '',
          schoolName: '',
          major: '',
          subMajor: '',
          graduationStatus: '',
          sortOrder: this.schools[index].sortOrder,
        };
        Vue.set(this.schools, index, resetSchoolItem);
      }
    },
    remove(index) {
      if (confirm('해당 추가정보를 삭제 하시겠습니까?')) {
        this.schools.splice(index, 1);
      }
    },
  },
  mounted() {

  },
});
</script>



// WEBPACK FOOTER //
// Schools.vue?1670b3ff